/* eslint-disable no-unused-vars */
export const getAutpApplyBannerStyle = (_, { palette = {} }) => ({
  recommendationAutoApplyBanner: {
    display: 'flex',
    alignItems: 'center',
    background: '#F7F7F7',
    paddingLeft: 24,
    '& .iconba': {
      marginRight: 5,
    },
    '& button.settings-page-link.btn-link': {
      color: palette.themePrimary,
    },
  },
});
